import React, { useContext, useState } from "react";
import { useGetIdentity, useNotify, usePermissions } from "react-admin";
import { useParams } from "react-router-dom";
import SyncIcon from "@mui/icons-material/Sync";
import DeleteFileConfirmBtn from "./DeleteFileConfirmBtn";
import { AiFillWarning } from "react-icons/ai";
import { MoveDocFileContext } from "../Ats/ApplicantDetailEdit";
import { ApplicantContext } from "../DocumentAnalysis";
import { checkModuleAccess, isSuperAdmin } from "../../Functions/permissions";
import ssn_masked_placeholder from '../../assets/images/ssn_masked_placeholder.png'
export default function FilePreview({
  img,
  is_Duplicate = 0,
  alt = "",
  doc_id,
  source_name = "",
  file_name = "",
  isId = false,
  tag,
  invalidateQueries,
  file = img,
  isDocUpload = false,
  handleClick,
  handledelete = () => { },
  ...props
}) {
  const Identity = useGetIdentity();
  const moveFileContext = useContext(MoveDocFileContext);
  const applicant = useContext(ApplicantContext);

  const { id, roletype, GuestCard } = useParams();
  const IsApplicant = roletype == "docupload_applicant" ? true : Identity?.data?.userrole == "applicant" ? true : false;


  const hasSSToken = (img = true, url) => {
    if (!img) {
      url = props?.fileObj?.path;
    }
    if (!url) {
      return url;
    } else if (url.includes("?")) {
      return url + "&";
    } else {
      return url;
    }
  };

  const { permissions } = usePermissions();
  const { data: getUserData } = useGetIdentity();
  const permissionToViewSSN = isSuperAdmin(checkModuleAccess(permissions, "View Docs", "View Proof of SSN"), getUserData?.userrole);
  const imageUrl = hasSSToken(true, img) + `?token=` + Identity.identity?.tokendata
  let imageUrlAsPerPermission = imageUrl;
  if(!permissionToViewSSN && source_name == "ssn"){
    imageUrlAsPerPermission = ssn_masked_placeholder
  }
  return (
    <>
      {img && (
        <div className="d-inline-flex flex-column flex-wrap">
          {is_Duplicate == 1 ? (
            <p className="muted text-warning small">
              <AiFillWarning /> {"Duplicate"}
            </p>
          ) : (
            <p>&nbsp;</p>
          )}

          {<img
            src={
              imageUrlAsPerPermission
            }
            style={{ maxWidth: "80px" }}
            className={"img-thumbnail ratio ratio-1x1"}
            alt=""
            onClick={handleClick}
          />}
          <div className="" style={{ textAlign: "center" }}>
            <p
              className="small pt-1"
              title={file_name}
              style={{ textAlign: "center", fontSize: 10 }}
            >
              {file_name
                ? `${file_name.substring(0, 9)}...`
                : img &&
                img
                  ?.split("/")
                  ?.pop()
                  ?.split("_")
                  ?.pop()
                  ?.substring(0, 15)
                  ?.replace(/%20/g, "")
                  ?.replace(/%2/g, "")
                  ?.replace(/%/g, "") + "..."}
            </p>

            <DeleteFileConfirmBtn
              doc_id={doc_id}
              invalidateQueries={invalidateQueries}
              tag={tag}
              petIndex={props?.petIndex} // passing index for pet images delete from store
              handleOnChange={props?.handleOnChange} // passing this to call onsubmit after uplode a pet images
            />


            {!IsApplicant && (

              <button
                type="button"
                onClick={() => {

                  moveFileContext?.setMoveFileState({
                    isOpen: true,
                    docId: doc_id,
                    trnID: applicant?.applicantInfo?.trnId,
                    applicantID: applicant?.applicantInfo?.applicantId,
                    source_index: props?.source_index,
                    source_name: source_name,
                  });
                }}
                className="btn btn-link print-hide"
                style={{
                  textAlign: "left",
                  fontSize: 10,
                  marginLeft: "1px",
                }}
              >
                <SyncIcon style={{ fontSize: 12 }} /> Move
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
}
